module.exports = __webpack_public_path__ + "static/img/2786_phase_function_Paper_Points.ca98014.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2786_phase_function_Paper_Points.png
// module id = hiep
// module chunks = 0